import { Directive, ElementRef } from '@angular/core';
import { UntillDone } from '@core/utils';

@Directive()
export abstract class AriaElement<T> {
  /**
   * valore label attuale
   */
  protected currentLabel: string;

  /**
   * classe per eseguire apply finchè risulta applicata
   */
  protected untillDone = new UntillDone(() => this.applyCurrentLabel(), {
    interval: 500
  });

  /**
   * flag per adeguare l'attributo aria-hidden in base alla presenza o meno del valore
   */
  protected adaptHidden: boolean;

  constructor(protected el: ElementRef<T>) {}

  /**
   * prova ad applicare l'aria label sugli elementi configurati
   * e restituisce esito operazione
   */
  protected applyCurrentLabel(): boolean {
    const applied = this.findElements().map(el => this.setAriaLabel(el));

    return applied.every(x => x);
  }

  /**
   * imposta aria label sull'elemento e restituisce esito
   */
  protected setAriaLabel(el: HTMLElement): boolean {
    if (!el) {
      return false;
    }

    el.setAttribute('aria-label', this.currentLabel || '');

    if (this.adaptHidden) {
      el.setAttribute('aria-hidden', this.currentLabel ? 'false' : 'true');
    }

    return true;
  }

  /**
   * metodo che deve resituire la lista di elementi su cui applicare l'aria label
   */
  abstract findElements(): HTMLElement[];
}
